export const HARDCODED_ACTOR_UUID = "6336dcc6-7942-4f98-b530-4bb7c592ec86"; //  TODO: remove once the api gateway gets ready

export function isMocksEnabled(): boolean {
  if (process.env.NODE_ENV === "test") {
    return true;
  }
  return process.env.REACT_APP_USE_MOCKS === "true";
}

export const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8000";
export const HOOKS_API_URL =
  process.env.REACT_APP_HOOKS_API_URL || "http://localhost:8001";
export const REACT_APP_WEB_URL =
  process.env.REACT_APP_WEB_URL || "http://localhost:4000";

const defaultMilliseconds = 500;

export async function buildMockPromise<T>(
  object: T,
  timeoutMilliseconds: number = defaultMilliseconds
): Promise<T> {
  const p = new Promise<T>((resolve, reject) => {
    setTimeout(() => {
      resolve(object);
    }, timeoutMilliseconds);
  });
  return p;
}

export async function buildEmptyMockPromise(
  timeoutMilliseconds: number = defaultMilliseconds
): Promise<void> {
  const p = new Promise<void>((resolve, reject) => {
    setTimeout(() => {
      resolve();
    }, timeoutMilliseconds);
  });
  return p;
}
